// extracted by mini-css-extract-plugin
export default {"InputContainer":"e3AWS0lR","Label":"vAlk7Ypf","Instructions":"_C4bigNl","InputContainerSkeleton":"N8kkHL_f","PlaceholderLabel":"Ep9wCvAF","PlaceholderInstructions":"d7W4PjEH"};